import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'
import { sendGTMEvent } from '@next/third-parties/google'
import { gtmClearEcommerceData } from '../../helpers/clearEcommerceData'
import { getEcommerceObjectFromProduct } from '../../helpers/getEccomerceObjectFromProduct'
import type { GtmGlobalStoreProps } from '../../useGTM'

export type GtmSelectItemProps = {
  product: CosmicProductType
}

const getGridPageCategoryLocation = () => {
  const url = window.location.href
  const parts = url.split('/products/')
  const result = parts[1]

  if (!result || result === '') {
    return 'products_shop_all'
  }

  return `products_${result.replace('/', '')}`
}

export const gtmSelectItem = ({
  globalStore,
  product,
}: GtmSelectItemProps & GtmGlobalStoreProps) => {
  if (!product) return

  const uuid = crypto.randomUUID()

  gtmClearEcommerceData()

  sendGTMEvent({
    event: 'select_item',
    event_id: uuid,
    ecommerce: {
      ...getEcommerceObjectFromProduct({ globalStore, product }),
      item_list_name: getGridPageCategoryLocation(),
    },
  })
}
